import LoginForm from "./LoginForm";
import "./Login.css";
import { Redirect } from "react-router-dom";

function Login(props: any) {
  if (props.isLogin) {
    return <Redirect to="/"></Redirect>;
  }
  return (
    <div className="backgraundLogin">
      <div className="boxLogin">
        <img
          className="logoLogin"
          src="/Assets/img/AF_AEDAS_POSITIVO_RGB.svg"
          alt="AEDAS Homes"
        ></img>
        <h1 className="appNameLogin">Aplicación de inventario</h1>
        <p className="descriptionLogin">
          Esta aplicación sirve como inventario de licencias de AEDAS Homes
        </p>
        <div className="buttonLogin">
          <LoginForm></LoginForm>
        </div>
      </div>
    </div>
  );
}

export default Login;
